export default __webpack_public_path__ + "static/Fotolia_100411286_M-7a6113656b5f39989587ade119e4a7d9.jpg";